import React, { useState, useEffect } from "react";
import {
  Dimensions,
  ScrollView,
  View,
  StyleSheet,
  Text,
  Platform,
  Keyboard,
} from "react-native";

import ChunkedIntegrationsSection from "../../integrations/details/ChunkedIntegrationsSection";
import { hasItems, isWeb, navigate } from "../../../../helpers/utils";
import fontStyles from "../../../fonts";
import IntegrationIcons from "../../common/icons/integrations";
import appPages from "../../../../appPages";
import ManaButton from "../../common/ManaButton";
import ImageComponent from "../../common/ImageComponent";
import IntegrationsHelper from "../../integrations/IntegrationsHelper";
import appStyles from "../../../appStyles";

const { height: HEIGHT } = Dimensions.get("window");

const COLLAPSED_HEIGHT = 78;
const FULL_HEIGHT = HEIGHT / 2 - (isWeb ? 100 : 200);

export default function TrackDetailIntegrations({
  controller,
  integration,
  timeslot,
  isLoading = false,
  //isSearchActive = false,
  onLongPress = () => {},
}) {
  const [maxHeight, setMaxHeight] = useState(FULL_HEIGHT);
  const [isCollapsed, setIsCollapsed] = useState(true);

  useEffect(() => {
    const showSubscription = Keyboard.addListener("keyboardDidShow", () => {
      setIsCollapsed(true);
    });

    return () => {
      showSubscription.remove();
    };
  }, []);

  useEffect(() => {
    setMaxHeight(isCollapsed ? COLLAPSED_HEIGHT : FULL_HEIGHT);
  }, [isCollapsed]);

  useEffect(() => {
    const showSubscription = Keyboard.addListener("keyboardDidShow", () => {
      setMaxHeight(40);
    });

    return () => {
      showSubscription.remove();
    };
  }, []);

  // ------------------------------------- METHODS -------------------------------------
  const filterItems = (items = []) => {
    return items.filter(
      (item) =>
        (item.source?.startTime <= startTime &&
          item.source?.endTime >= startTime) ||
        (item.source?.startTime <= endTime &&
          item.source?.endTime >= endTime) ||
        (item.source?.startTime >= startTime &&
          item.source?.endTime <= endTime),
    );
  };

  const goToIntegrationsPage = () => {
    navigate(controller, appPages.integrationsV2);
  };

  const startTime = timeslot.time;
  const endTime = timeslot.endDate;

  const activeIntegrations = filterItems(integration?.activeIntegrations);
  const isOffline = !hasItems(activeIntegrations);
  const hasIntegrationsEnabled =
    IntegrationsHelper.hasEnabledIntegrations(controller);

  return (
    <ScrollView
      contentContainerStyle={appStyles.contentContainerStyle}
      keyboardShouldPersistTaps="handled"
      style={[
        {
          backgroundColor: "#F5F5F5",
          paddingBottom: 6,
          minHeight: COLLAPSED_HEIGHT,
          maxHeight: maxHeight,
          flexGrow: 0,
        },
        isLoading || isOffline || !hasIntegrationsEnabled
          ? { maxHeight: COLLAPSED_HEIGHT }
          : {},
      ]}
    >
      <Text style={styles.sectionText}>Active Integrations</Text>

      {/* Loading */}
      {isLoading ? (
        <View style={styles.loadingContainer}>
          <Text style={fontStyles.subtitleItalicsBold}>
            Loading, please wait...
          </Text>
        </View>
      ) : /* Not connected */
      !hasIntegrationsEnabled ? (
        <View style={styles.noIntegrationsContainer}>
          <View>
            <Text style={fontStyles.subtitleItalicsBold}>
              Oh no, you haven’t connected integrations!
            </Text>
            <ManaButton
              isMainButton
              style={[styles.button]}
              styleText={styles.buttonText}
              text="Connect for easier tracking"
              onPress={goToIntegrationsPage}
            />
          </View>
          <ImageComponent
            image={require("../../../../assets/integrations/confusedMari.png")}
            style={{
              width: 74,
              height: 70,
            }}
          />
        </View>
      ) : /* Has no integration data */
      isOffline ? (
        <View style={styles.offlineContainer}>
          <Text style={[fontStyles.subtitleItalicsBold, { maxWidth: 227 }]}>
            We don’t see any integration data, and hope you enjoyed offline
            time!
          </Text>
          <IntegrationIcons.DogWalkingIcon />
        </View>
      ) : (
        <ChunkedIntegrationsSection
          controller={controller}
          integrations={activeIntegrations}
          timeslot={timeslot}
          isCollapsed={isCollapsed}
          onLongPress={onLongPress}
          expandContainer={(val) => setIsCollapsed(val)}
        />
      )}
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  sectionText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#8B92A1",
    marginTop: 8,
    marginLeft: 9,
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: "10%",
    flex: 1,
  },
  offlineContainer: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    paddingLeft: 8,
    paddingRight: 16,
  },
  noIntegrationsContainer: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    paddingLeft: 8,
    paddingRight: 16,
  },
  button: {
    width: 256,
    height: 32,
    marginTop: 6,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
});
